import {
  QBO_BULK_SYNC_FEATURE,
  QBO_SYNC_EXCLUSION_RULES_FEATURE,
  QUICKBOOKS_ADJUSTMENT_TYPES_FEATURE,
  QUICKBOOKS_DEFAULT_MAPPINGS_FEATURE,
  QUICKBOOKS_PRODUCTS_FEATURE,
  QUICKBOOKS_TOKENS_FEATURE
} from "constants/feature-flags";

import inSection from "./in-section.util";

export const QUICKBOOKS_DESTINATIONS = inSection("/quickbooks", [
  { to: "sync-exceptions", label: "Sync Exceptions" },
  {
    to: "sync-exceptions/manual-scheduled-syncs",
    label: "Manual Sync Jobs Scheduled",
    trail: ["Sync Exceptions"],
    featureFlag: QBO_BULK_SYNC_FEATURE
  },
  {
    to: "sync-exceptions/manual-completed-syncs",
    label: "Manual Sync Jobs Completed",
    trail: ["Sync Exceptions"],
    featureFlag: QBO_BULK_SYNC_FEATURE
  },
  { to: "tokens", label: "Tokens", featureFlag: QUICKBOOKS_TOKENS_FEATURE },
  { to: "vendors", label: "Vendors" },
  {
    to: "products",
    label: "Products",
    featureFlag: QUICKBOOKS_PRODUCTS_FEATURE
  },
  {
    to: "default-mappings",
    label: "Default Mappings",
    featureFlag: QUICKBOOKS_DEFAULT_MAPPINGS_FEATURE
  },
  {
    to: "adjustment-types",
    label: "Adjustment Types",
    featureFlag: QUICKBOOKS_ADJUSTMENT_TYPES_FEATURE
  },
  { to: "refunds", label: "Refunds" },
  { to: "class-mappings", label: "Class Mappings" },
  {
    to: "sync-exclusions",
    label: "Sync Exclusions",
    featureFlag: QBO_SYNC_EXCLUSION_RULES_FEATURE
  },
  { to: "taxes", label: "Taxes" },
  { to: "faq", label: "FAQ" }
]);
